import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../../hoc/Auxilliary";
import Schedule from "../../../components/Students/Schedule";

function SchedulePage(props) {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={11} sm={10} style={{ margin: "0 auto" }}>
          <Schedule {...props} />
        </Grid>
      </Grid>
    </Aux>
  );
}

export default SchedulePage;
